/* eslint-disable no-shadow */
export enum FinancialsObjectType {
  OKR = 1,
  KR = 2,
}

export enum FinancialType {
  Budget = 1,
  Resources = 2,
  Cost = 3,
}

export enum FinancialCadence {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Quarterly = 4,
}

export const WOBO_APP_IDS = {
  JIRA_KPI: 28,
  EXCEL: 23,
  AZURE_DEVOPS_KPI: 41,
  MS_PLANNER: 11,
}
